const storageKey = 'familyCopilotUser';
const storageVersion = 'firebase-uid-v1';

function safeGetLocalStorageItem(key) {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSetLocalStorageItem(key, value) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(key, value);
  } catch {
    // ignore storage failures
  }
}

function safeRemoveLocalStorageItem(key) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.removeItem(key);
  } catch {
    // ignore removal failures
  }
}

export function loadStoredSession() {
  const value = safeGetLocalStorageItem(storageKey);
  if (!value) {
    return { user: null };
  }

  try {
    const parsed = JSON.parse(value);
    if (parsed?.storageVersion !== storageVersion || !parsed?.userId || !parsed?.email) {
      safeRemoveLocalStorageItem(storageKey);
      return { user: null };
    }

    return {
      user: {
        userId: parsed.userId,
        firebaseUid: parsed.firebaseUid || parsed.userId,
        email: parsed.email,
        name: parsed.name || '',
        featureFlags: parsed.featureFlags || {},
      },
    };
  } catch {
    safeRemoveLocalStorageItem(storageKey);
    return { user: null };
  }
}

export function saveStoredUser(user) {
  if (!user) {
    return;
  }

  safeSetLocalStorageItem(
    storageKey,
    JSON.stringify({
      ...user,
      firebaseUid: user.firebaseUid || user.userId,
      featureFlags: user.featureFlags || {},
      storageVersion,
    })
  );
}

export function clearStoredSession() {
  safeRemoveLocalStorageItem(storageKey);
}

const processingStorageKey = 'familyCopilotActiveProcessing';

export function saveStoredProcessing(processing) {
  if (!processing?.queueId || !processing?.jobId) {
    safeRemoveLocalStorageItem(processingStorageKey);
    return;
  }

  safeSetLocalStorageItem(processingStorageKey, JSON.stringify(processing));
}

export function clearStoredProcessing() {
  safeRemoveLocalStorageItem(processingStorageKey);
}
